const shot = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const photos = {
  hero: shot('photo-1571019613454-1cb2f99b2d8b', 2000),
  gym: shot('photo-1581009146145-b5ef050c2e1e', 1400),
  lift: shot('photo-1599058945522-28d584b6f14f', 1200),
  hiit: shot('photo-1518310383802-640c2de311b2', 1200),
  yoga: shot('photo-1599901860904-17e6ed7083a0', 1200),
  bowl: shot('photo-1512621776951-a57141f2eefd', 1200),
  chicken: shot('photo-1604908176997-125f25cc6f3d', 1200),
  meal: shot('photo-1547592180-85f173990554', 1600),
  market: shot('photo-1488459716781-31db52582fe9', 1600),
  run: shot('photo-1476480862126-209bfaa8edc8', 2000),
  fresh: shot('photo-1490818387583-1baba5e638af', 1200),
};
